// Comprehensive Payment Methods Configuration by Country
// Priority countries: USA, Canada, India, Germany, Ireland (70% of users)

export const PAYMENT_METHODS_CONFIG = {
  // ========================
  // PRIORITY COUNTRIES (70% of users)
  // ========================

  US: {
    countryName: "United States",
    currency: "USD",
    flag: "🇺🇸",
    paymentMethods: {
      bank_transfer: {
        name: "Bank Transfer (ACH)",
        icon: "🏦",
        popular: true,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "bank_name",
            label: "Bank Name",
            type: "text",
            required: true,
          },
          {
            name: "account_number",
            label: "Account Number",
            type: "text",
            required: true,
          },
          {
            name: "routing_number",
            label: "Routing Number",
            type: "text",
            required: true,
            pattern: /^\d{9}$/,
            placeholder: "123456789",
          },
          {
            name: "account_type",
            label: "Account Type",
            type: "select",
            required: true,
            options: [
              { value: "checking", label: "Checking" },
              { value: "savings", label: "Savings" },
            ],
          },
          {
            name: "bank_address",
            label: "Bank Address",
            type: "text",
            required: false,
          },
        ],
        validation: {
          routing_number: "Must be 9 digits",
          account_number: "Must be valid account number",
        },
        processingTime: "1-3 business days",
        fees: "$0",
      },
      wire_transfer: {
        name: "Wire Transfer",
        icon: "💰",
        popular: false,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "bank_name",
            label: "Bank Name",
            type: "text",
            required: true,
          },
          {
            name: "account_number",
            label: "Account Number",
            type: "text",
            required: true,
          },
          {
            name: "routing_number",
            label: "Routing Number",
            type: "text",
            required: true,
            pattern: /^\d{9}$/,
          },
          {
            name: "swift_code",
            label: "SWIFT Code",
            type: "text",
            required: true,
            pattern: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
          },
          {
            name: "bank_address",
            label: "Bank Address",
            type: "textarea",
            required: true,
          },
        ],
        processingTime: "Same day",
        fees: "$25-45",
      },
      paypal: {
        name: "PayPal",
        icon: "💙",
        popular: true,
        fields: [
          {
            name: "paypal_email",
            label: "PayPal Email",
            type: "email",
            required: true,
          },
          {
            name: "paypal_name",
            label: "PayPal Account Name",
            type: "text",
            required: true,
          },
        ],
        processingTime: "Instant",
        fees: "2.9% + $0.30",
      },
      cashapp: {
        name: "Cash App",
        icon: "💚",
        popular: true,
        fields: [
          {
            name: "cashapp_handle",
            label: "Cash App Handle ($cashtag)",
            type: "text",
            required: true,
            pattern: /^\$[a-zA-Z0-9]{1,20}$/,
            placeholder: "$YourCashTag",
          },
        ],
        processingTime: "Instant",
        fees: "$0",
      },
      venmo: {
        name: "Venmo",
        icon: "🔵",
        popular: false,
        fields: [
          {
            name: "venmo_handle",
            label: "Venmo Username",
            type: "text",
            required: true,
            pattern: /^@[a-zA-Z0-9-_]{5,30}$/,
            placeholder: "@username",
          },
        ],
        processingTime: "Instant",
        fees: "$0",
      },
    },
  },

  CA: {
    countryName: "Canada",
    currency: "CAD",
    flag: "🇨🇦",
    paymentMethods: {
      bank_transfer: {
        name: "Bank Transfer (EFT)",
        icon: "🏦",
        popular: true,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "bank_name",
            label: "Bank Name",
            type: "text",
            required: true,
          },
          {
            name: "account_number",
            label: "Account Number",
            type: "text",
            required: true,
          },
          {
            name: "institution_number",
            label: "Institution Number",
            type: "text",
            required: true,
            pattern: /^\d{3}$/,
            placeholder: "123",
          },
          {
            name: "transit_number",
            label: "Transit Number",
            type: "text",
            required: true,
            pattern: /^\d{5}$/,
            placeholder: "12345",
          },
          {
            name: "account_type",
            label: "Account Type",
            type: "select",
            required: true,
            options: [
              { value: "checking", label: "Checking" },
              { value: "savings", label: "Savings" },
            ],
          },
        ],
        processingTime: "1-2 business days",
        fees: "$0",
      },
      wire_transfer: {
        name: "Wire Transfer",
        icon: "💰",
        popular: false,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "bank_name",
            label: "Bank Name",
            type: "text",
            required: true,
          },
          {
            name: "account_number",
            label: "Account Number",
            type: "text",
            required: true,
          },
          {
            name: "swift_code",
            label: "SWIFT Code",
            type: "text",
            required: true,
            pattern: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
          },
          {
            name: "bank_address",
            label: "Bank Address",
            type: "textarea",
            required: true,
          },
        ],
        processingTime: "Same day",
        fees: "$15-30 CAD",
      },
      paypal: {
        name: "PayPal",
        icon: "💙",
        popular: true,
        fields: [
          {
            name: "paypal_email",
            label: "PayPal Email",
            type: "email",
            required: true,
          },
          {
            name: "paypal_name",
            label: "PayPal Account Name",
            type: "text",
            required: true,
          },
        ],
        processingTime: "Instant",
        fees: "2.9% + $0.30 CAD",
      },
      interac: {
        name: "Interac e-Transfer",
        icon: "🔄",
        popular: true,
        fields: [
          {
            name: "email",
            label: "Email Address",
            type: "email",
            required: true,
          },
          {
            name: "security_question",
            label: "Security Question",
            type: "text",
            required: true,
          },
          {
            name: "security_answer",
            label: "Security Answer",
            type: "text",
            required: true,
          },
        ],
        processingTime: "Instant",
        fees: "$1.50 CAD",
      },
    },
  },

  IN: {
    countryName: "India",
    currency: "INR",
    flag: "🇮🇳",
    paymentMethods: {
      bank_transfer: {
        name: "Bank Transfer (NEFT/RTGS)",
        icon: "🏦",
        popular: true,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "bank_name",
            label: "Bank Name",
            type: "text",
            required: true,
          },
          {
            name: "account_number",
            label: "Account Number",
            type: "text",
            required: true,
          },
          {
            name: "ifsc_code",
            label: "IFSC Code",
            type: "text",
            required: true,
            pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/,
            placeholder: "SBIN0001234",
          },
          {
            name: "account_type",
            label: "Account Type",
            type: "select",
            required: true,
            options: [
              { value: "savings", label: "Savings" },
              { value: "current", label: "Current" },
            ],
          },
          {
            name: "branch_name",
            label: "Branch Name",
            type: "text",
            required: false,
          },
        ],
        validation: {
          ifsc_code: "Must be valid IFSC code (e.g., SBIN0001234)",
        },
        processingTime: "2-24 hours",
        fees: "₹0",
      },
      upi: {
        name: "UPI (Unified Payments Interface)",
        icon: "📱",
        popular: true,
        fields: [
          {
            name: "upi_id",
            label: "UPI ID",
            type: "text",
            required: true,
            pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z]+$/,
            placeholder: "yourname@paytm",
          },
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
        ],
        processingTime: "Instant",
        fees: "₹0",
      },
      paytm: {
        name: "Paytm",
        icon: "💸",
        popular: true,
        fields: [
          {
            name: "paytm_number",
            label: "Paytm Mobile Number",
            type: "tel",
            required: true,
            pattern: /^[6-9]\d{9}$/,
            placeholder: "9876543210",
          },
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
        ],
        processingTime: "Instant",
        fees: "₹0",
      },
      paypal: {
        name: "PayPal",
        icon: "💙",
        popular: false,
        fields: [
          {
            name: "paypal_email",
            label: "PayPal Email",
            type: "email",
            required: true,
          },
          {
            name: "paypal_name",
            label: "PayPal Account Name",
            type: "text",
            required: true,
          },
        ],
        processingTime: "1-2 business days",
        fees: "4.4% + ₹35",
      },
    },
  },

  DE: {
    countryName: "Germany",
    currency: "EUR",
    flag: "🇩🇪",
    paymentMethods: {
      sepa_transfer: {
        name: "SEPA Bank Transfer",
        icon: "🏦",
        popular: true,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "iban",
            label: "IBAN",
            type: "text",
            required: true,
            pattern: /^DE\d{20}$/,
            placeholder: "DE89370400440532013000",
          },
          {
            name: "bic",
            label: "BIC/SWIFT Code",
            type: "text",
            required: true,
            pattern: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
            placeholder: "DEUTDEFF",
          },
          {
            name: "bank_name",
            label: "Bank Name",
            type: "text",
            required: false,
          },
        ],
        validation: {
          iban: "Must be valid German IBAN starting with DE",
        },
        processingTime: "1-2 business days",
        fees: "€0",
      },
      wire_transfer: {
        name: "Wire Transfer",
        icon: "💰",
        popular: false,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "iban",
            label: "IBAN",
            type: "text",
            required: true,
            pattern: /^DE\d{20}$/,
          },
          {
            name: "swift_code",
            label: "SWIFT Code",
            type: "text",
            required: true,
            pattern: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
          },
          {
            name: "bank_name",
            label: "Bank Name",
            type: "text",
            required: true,
          },
          {
            name: "bank_address",
            label: "Bank Address",
            type: "textarea",
            required: true,
          },
        ],
        processingTime: "Same day",
        fees: "€15-25",
      },
      paypal: {
        name: "PayPal",
        icon: "💙",
        popular: true,
        fields: [
          {
            name: "paypal_email",
            label: "PayPal Email",
            type: "email",
            required: true,
          },
          {
            name: "paypal_name",
            label: "PayPal Account Name",
            type: "text",
            required: true,
          },
        ],
        processingTime: "Instant",
        fees: "3.4% + €0.35",
      },
    },
  },

  IE: {
    countryName: "Ireland",
    currency: "EUR",
    flag: "🇮🇪",
    paymentMethods: {
      sepa_transfer: {
        name: "SEPA Bank Transfer",
        icon: "🏦",
        popular: true,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "iban",
            label: "IBAN",
            type: "text",
            required: true,
            pattern: /^IE\d{2}[A-Z]{4}\d{14}$/,
            placeholder: "IE29AIBK93115212345678",
          },
          {
            name: "bic",
            label: "BIC/SWIFT Code",
            type: "text",
            required: true,
            pattern: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
            placeholder: "AIBKIE2D",
          },
          {
            name: "bank_name",
            label: "Bank Name",
            type: "text",
            required: false,
          },
        ],
        validation: {
          iban: "Must be valid Irish IBAN starting with IE",
        },
        processingTime: "1-2 business days",
        fees: "€0",
      },
      paypal: {
        name: "PayPal",
        icon: "💙",
        popular: true,
        fields: [
          {
            name: "paypal_email",
            label: "PayPal Email",
            type: "email",
            required: true,
          },
          {
            name: "paypal_name",
            label: "PayPal Account Name",
            type: "text",
            required: true,
          },
        ],
        processingTime: "Instant",
        fees: "3.4% + €0.35",
      },
    },
  },

  // ========================
  // OTHER MAJOR COUNTRIES
  // ========================

  BR: {
    countryName: "Brazil",
    currency: "BRL",
    flag: "🇧🇷",
    paymentMethods: {
      pix: {
        name: "PIX",
        icon: "⚡",
        popular: true,
        fields: [
          {
            name: "pix_key",
            label: "PIX Key",
            type: "text",
            required: true,
            placeholder: "CPF, Email, Phone, or Random Key",
          },
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
        ],
        processingTime: "Instant",
        fees: "R$0",
      },
      bank_transfer: {
        name: "Bank Transfer (TED/DOC)",
        icon: "🏦",
        popular: true,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "cpf",
            label: "CPF",
            type: "text",
            required: true,
            pattern: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/,
            placeholder: "123.456.789-00",
          },
          {
            name: "bank_code",
            label: "Bank Code",
            type: "text",
            required: true,
            pattern: /^\d{3}$/,
            placeholder: "001",
          },
          { name: "agency", label: "Agency", type: "text", required: true },
          {
            name: "account_number",
            label: "Account Number",
            type: "text",
            required: true,
          },
          {
            name: "account_type",
            label: "Account Type",
            type: "select",
            required: true,
            options: [
              { value: "conta_corrente", label: "Conta Corrente" },
              { value: "conta_poupanca", label: "Conta Poupança" },
            ],
          },
        ],
        processingTime: "Same day",
        fees: "R$0",
      },
    },
  },

  MX: {
    countryName: "Mexico",
    currency: "MXN",
    flag: "🇲🇽",
    paymentMethods: {
      bank_transfer: {
        name: "Bank Transfer (SPEI)",
        icon: "🏦",
        popular: true,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "clabe",
            label: "CLABE",
            type: "text",
            required: true,
            pattern: /^\d{18}$/,
            placeholder: "123456789012345678",
          },
          {
            name: "bank_name",
            label: "Bank Name",
            type: "text",
            required: false,
          },
        ],
        processingTime: "Instant",
        fees: "MX$0",
      },
      paypal: {
        name: "PayPal",
        icon: "💙",
        popular: true,
        fields: [
          {
            name: "paypal_email",
            label: "PayPal Email",
            type: "email",
            required: true,
          },
          {
            name: "paypal_name",
            label: "PayPal Account Name",
            type: "text",
            required: true,
          },
        ],
        processingTime: "Instant",
        fees: "4.9% + MX$4.00",
      },
    },
  },

  PK: {
    countryName: "Pakistan",
    currency: "PKR",
    flag: "🇵🇰",
    paymentMethods: {
      bank_transfer: {
        name: "Bank Transfer",
        icon: "🏦",
        popular: true,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "bank_name",
            label: "Bank Name",
            type: "text",
            required: true,
          },
          {
            name: "account_number",
            label: "Account Number",
            type: "text",
            required: true,
          },
          {
            name: "iban",
            label: "IBAN",
            type: "text",
            required: true,
            pattern: /^PK\d{2}[A-Z]{4}\d{16}$/,
            placeholder: "PK12ABCD0000123456789012",
          },
        ],
        processingTime: "1-2 business days",
        fees: "PKR 50-100",
      },
      easypaisa: {
        name: "EasyPaisa",
        icon: "📱",
        popular: true,
        fields: [
          {
            name: "mobile_number",
            label: "Mobile Number",
            type: "tel",
            required: true,
            pattern: /^(\+92|0)?3\d{9}$/,
            placeholder: "+923001234567",
          },
          {
            name: "account_name",
            label: "Account Name",
            type: "text",
            required: true,
          },
        ],
        processingTime: "Instant",
        fees: "PKR 0-20",
      },
      jazzcash: {
        name: "JazzCash",
        icon: "📱",
        popular: true,
        fields: [
          {
            name: "mobile_number",
            label: "Mobile Number",
            type: "tel",
            required: true,
            pattern: /^(\+92|0)?3\d{9}$/,
            placeholder: "+923001234567",
          },
          {
            name: "account_name",
            label: "Account Name",
            type: "text",
            required: true,
          },
        ],
        processingTime: "Instant",
        fees: "PKR 0-20",
      },
    },
  },

  AE: {
    countryName: "United Arab Emirates",
    currency: "AED",
    flag: "🇦🇪",
    paymentMethods: {
      bank_transfer: {
        name: "Bank Transfer",
        icon: "🏦",
        popular: true,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "bank_name",
            label: "Bank Name",
            type: "text",
            required: true,
          },
          {
            name: "iban",
            label: "IBAN",
            type: "text",
            required: true,
            pattern: /^AE\d{2}\d{3}\d{16}$/,
            placeholder: "AE123456789012345678901",
          },
          {
            name: "swift_code",
            label: "SWIFT Code",
            type: "text",
            required: true,
            pattern: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
          },
        ],
        processingTime: "Same day",
        fees: "AED 25-50",
      },
    },
  },

  NG: {
    countryName: "Nigeria",
    currency: "NGN",
    flag: "🇳🇬",
    paymentMethods: {
      bank_transfer: {
        name: "Bank Transfer",
        icon: "🏦",
        popular: true,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "bank_name",
            label: "Bank Name",
            type: "text",
            required: true,
          },
          {
            name: "account_number",
            label: "Account Number",
            type: "text",
            required: true,
            pattern: /^\d{10}$/,
            placeholder: "0123456789",
          },
          {
            name: "bank_code",
            label: "Bank Code",
            type: "text",
            required: true,
            pattern: /^\d{3}$/,
            placeholder: "011",
          },
        ],
        processingTime: "Instant",
        fees: "NGN 50-100",
      },
    },
  },

  AU: {
    countryName: "Australia",
    currency: "AUD",
    flag: "🇦🇺",
    paymentMethods: {
      bank_transfer: {
        name: "Bank Transfer",
        icon: "🏦",
        popular: true,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "bsb",
            label: "BSB Number",
            type: "text",
            required: true,
            pattern: /^\d{3}-\d{3}$/,
            placeholder: "123-456",
          },
          {
            name: "account_number",
            label: "Account Number",
            type: "text",
            required: true,
            pattern: /^\d{4,10}$/,
          },
          {
            name: "bank_name",
            label: "Bank Name",
            type: "text",
            required: true,
          },
        ],
        processingTime: "1-2 business days",
        fees: "AUD 0-5",
      },
      paypal: {
        name: "PayPal",
        icon: "💙",
        popular: true,
        fields: [
          {
            name: "paypal_email",
            label: "PayPal Email",
            type: "email",
            required: true,
          },
          {
            name: "paypal_name",
            label: "PayPal Account Name",
            type: "text",
            required: true,
          },
        ],
        processingTime: "Instant",
        fees: "4.9% + AUD 0.30",
      },
    },
  },

  CN: {
    countryName: "China",
    currency: "CNY",
    flag: "🇨🇳",
    paymentMethods: {
      bank_transfer: {
        name: "Bank Transfer",
        icon: "🏦",
        popular: true,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "bank_name",
            label: "Bank Name",
            type: "text",
            required: true,
          },
          {
            name: "account_number",
            label: "Account Number",
            type: "text",
            required: true,
          },
          {
            name: "swift_code",
            label: "SWIFT Code",
            type: "text",
            required: true,
            pattern: /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/,
          },
        ],
        processingTime: "1-3 business days",
        fees: "CNY 50-100",
      },
      alipay: {
        name: "Alipay",
        icon: "💙",
        popular: true,
        fields: [
          {
            name: "alipay_account",
            label: "Alipay Account",
            type: "text",
            required: true,
          },
          {
            name: "account_name",
            label: "Account Name",
            type: "text",
            required: true,
          },
        ],
        processingTime: "Instant",
        fees: "CNY 0-10",
      },
    },
  },

  GB: {
    countryName: "United Kingdom",
    currency: "GBP",
    flag: "🇬🇧",
    paymentMethods: {
      bank_transfer: {
        name: "Bank Transfer",
        icon: "🏦",
        popular: true,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "sort_code",
            label: "Sort Code",
            type: "text",
            required: true,
            pattern: /^\d{2}-\d{2}-\d{2}$/,
            placeholder: "12-34-56",
          },
          {
            name: "account_number",
            label: "Account Number",
            type: "text",
            required: true,
            pattern: /^\d{8}$/,
            placeholder: "12345678",
          },
          {
            name: "bank_name",
            label: "Bank Name",
            type: "text",
            required: true,
          },
        ],
        processingTime: "Same day",
        fees: "£0-5",
      },
      paypal: {
        name: "PayPal",
        icon: "💙",
        popular: true,
        fields: [
          {
            name: "paypal_email",
            label: "PayPal Email",
            type: "email",
            required: true,
          },
          {
            name: "paypal_name",
            label: "PayPal Account Name",
            type: "text",
            required: true,
          },
        ],
        processingTime: "Instant",
        fees: "4.9% + £0.30",
      },
    },
  },

  RU: {
    countryName: "Russia",
    currency: "RUB",
    flag: "🇷🇺",
    paymentMethods: {
      bank_transfer: {
        name: "Bank Transfer",
        icon: "🏦",
        popular: true,
        fields: [
          {
            name: "account_holder_name",
            label: "Account Holder Name",
            type: "text",
            required: true,
          },
          {
            name: "bank_name",
            label: "Bank Name",
            type: "text",
            required: true,
          },
          {
            name: "account_number",
            label: "Account Number",
            type: "text",
            required: true,
            pattern: /^\d{20}$/,
            placeholder: "12345678901234567890",
          },
          {
            name: "bik",
            label: "BIK",
            type: "text",
            required: true,
            pattern: /^\d{9}$/,
            placeholder: "123456789",
          },
        ],
        processingTime: "1-2 business days",
        fees: "₽50-200",
      },
    },
  },

  OTHER: {
    countryName: "Other",
    currency: "USD",
    flag: "🌍",
    paymentMethods: {
      bank_transfer: {
        name: "Bank Transfer",
        icon: "🏦",
        popular: true,
        fields: [
          {
            name: "bank_details",
            label: "Bank Details",
            type: "textarea",
            required: true,
            placeholder:
              "Please provide all bank details required for transfer including:\n- Account holder name\n- Bank name\n- Account number\n- SWIFT/BIC code\n- Bank address\n- Any other required information",
            helpText:
              "Include all information needed for international bank transfer to your account",
          },
        ],
        processingTime: "3-5 business days",
        fees: "$25-50",
      },
      other_payment: {
        name: "Other Payment Method",
        icon: "💳",
        popular: false,
        fields: [
          {
            name: "payment_method_name",
            label: "Payment Method Name",
            type: "text",
            required: true,
            placeholder: "e.g., Revolut, Wise, local payment service",
            helpText: "What is this payment method called in your country?",
          },
          {
            name: "payment_details",
            label: "Payment Details",
            type: "textarea",
            required: true,
            placeholder:
              "Please provide all details needed to send payment:\n- Email address\n- Username/ID\n- Phone number\n- Any other required information",
            helpText:
              "Include all information needed to send payment via this method",
          },
        ],
        processingTime: "1-5 business days",
        fees: "Varies",
      },
    },
  },
};

// Helper functions
export const getCountriesForPayment = () => {
  return Object.keys(PAYMENT_METHODS_CONFIG).map((code) => ({
    value: code,
    label: PAYMENT_METHODS_CONFIG[code].countryName,
    flag: PAYMENT_METHODS_CONFIG[code].flag,
    currency: PAYMENT_METHODS_CONFIG[code].currency,
  }));
};

export const getPaymentMethodsForCountry = (countryCode) => {
  if (!PAYMENT_METHODS_CONFIG[countryCode]) return [];

  const methods = PAYMENT_METHODS_CONFIG[countryCode].paymentMethods;
  return Object.keys(methods).map((key) => ({
    value: key,
    ...methods[key],
    popular: methods[key].popular || false,
  }));
};

export const getPaymentMethodConfig = (countryCode, methodKey) => {
  return (
    PAYMENT_METHODS_CONFIG[countryCode]?.paymentMethods?.[methodKey] || null
  );
};

export const validatePaymentField = (
  countryCode,
  methodKey,
  fieldName,
  value
) => {
  const method = getPaymentMethodConfig(countryCode, methodKey);
  if (!method) return { isValid: true };

  const field = method.fields.find((f) => f.name === fieldName);
  if (!field) return { isValid: true };

  // Required field validation
  if (field.required && (!value || value.trim() === "")) {
    return {
      isValid: false,
      error: `${field.label} is required`,
    };
  }

  // Pattern validation
  if (field.pattern && value && !field.pattern.test(value)) {
    const customError = method.validation?.[fieldName];
    return {
      isValid: false,
      error: customError || `Invalid ${field.label.toLowerCase()} format`,
    };
  }

  return { isValid: true };
};
